import Toast from '../../component/toastify/Index';
import axios from './../../axios/interceptor.js';

export const getuser = async (payload) => {
    try {
        const response = await axios.post('/superAdmin/getAllSuperAdmins', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const adduser = async (payload) => {
    try {
        const response = await axios.post('/superAdmin/createSuperAdmin', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateUser = async (id, payload) => {
    try {
        const response = await axios.put('/superAdmin/updateSuperAdmin/' + id, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteUser = async (id) => {
    try {
        const response = await axios.put('/superAdmin/deleteSuperAdmin/' + id, { isDelete: true })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const toggleAdminUserStatus = async (id, isDelete) => {
    try {
        const response = await axios.put(`/superAdmin/toggleAdminUserStatus/${id}`, { isDelete: isDelete })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const getSingleUser = async (id) => {
    try {
        const response = await axios.get(`/superAdmin/getSuperAdminById/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const resendEmail = async (email) => {
    try {
        const response = await axios.post(`/superAdmin/resendInvitation/${email}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message ? error?.response?.data?.message ? error?.response?.data?.message : error?.message : error?.message, "error");
    }
}